import { render, staticRenderFns } from "./AppTypographyIcon.vue?vue&type=template&id=1adb7e78&"
import script from "./AppTypographyIcon.vue?vue&type=script&lang=js&"
export * from "./AppTypographyIcon.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports